import { ensureConfigTypes } from '@/domain/hooks/useWrite'
import { toBigInt } from '@/utils/bigNumber'
import { ActionConfig, ActionContext } from '../../../logic/types'
import { FRAXLEND_PAIR_ABI } from '@/config/abis/FraxlendPair.abi'
import { IsolatedBorrowAction } from '../types'
import { getPortfolioBalanceInvalidationKeys } from '@/features/actions/logic/invalidation'

export function createIsolatedBorrowActionConfig(action: IsolatedBorrowAction, context: ActionContext): ActionConfig {
  const { account, chainId, isolatedInfo } = context

  return {
    getWriteConfig: () => {
      const depositAmount = toBigInt(action.token.toBaseUnit(action.value))

      return ensureConfigTypes({
        abi: FRAXLEND_PAIR_ABI,
        address: isolatedInfo?.pairAddress,
        functionName: 'borrowAsset',
        chainId,
        args: [depositAmount, 0n, account],
      })
    },

    invalidates: () => getPortfolioBalanceInvalidationKeys({ account, chainId }),
  }
}
